<template>
    <div>
        <p>Personne : <b class="text-primary">{{ associate.type }}</b></p>

        <p>Genre : <b class="text-primary">{{ associate.sex }}</b></p>
        <p><span v-if="associate.sex === 'Masculin'">Nom : </span> <span v-else>Nom de naissance : </span> <b class="text-primary">{{ associate.name.firstName }} <span v-if="associate.sex === 'Masculin'">{{ associate.name.lastName }}</span> <span v-else>{{ associate.name.birthName }}</span></b></p>

        <div v-if="associate.type === 'Physique'">
            <p>Statut marital: <b class="text-primary">{{ associate.maritalStatus }}</b></p>
						<p v-if="associate.maritalStatus === 'Mariée' && associate.sex === 'Féminin'">Nom marital : <b class="text-primary">{{ associate.name.maritalName }}</b></p>
            <p v-if="associate.maritalStatus === 'Marié' || associate.maritalStatus === 'Mariée'">Marié sous la communauté de biens : <b class="text-primary"><span v-if="associate.marriedUnderCommunityOfProperty == 'true'">Oui</span><span v-else>Non</span></b></p>
            <p>Né le : <b class="text-primary" v-if="associate.birth.day">{{ associate.birth.day }}</b> <span v-if="associate.birth.day && associate.birth.city">à</span> <b class="text-primary">{{ associate.birth.city }}</b> <b class="text-primary" v-if="associate.birth.city && associate.birth.zipCode"> ({{ associate.birth.zipCode }})</b> <span v-if="associate.birth.day && associate.birth.country">en</span> <b class="text-primary">{{ associate.birth.country }}</b></p>
            <p>Nationalité : <b class="text-primary">{{ associate.birth.nationality }}</b></p>
            <p>Adresse : <b class="text-primary">{{ associate.address.place }}<span v-if="associate.address.place && associate.address.zipCode">,</span> {{ associate.address.zipCode }} {{ associate.address.city }}</b></p>
        </div>

        <div v-else>
            <p>Nom de la société : <b class="text-primary">{{ associate.company.name }}</b></p>
            <p>Numéro RCS : <b class="text-primary">{{ associate.company.rcs }}</b></p>
            <p>Adresse du siège social : <b class="text-primary">{{ associate.company.headOffice.place }}<span v-if="associate.company.headOffice.place && associate.company.headOffice.zipCode">,</span> {{ associate.company.headOffice.zipCode }} {{ associate.company.headOffice.city }}</b></p>
            <p>Ville du Greffe : <b class="text-primary">{{ associate.company.headOffice.registry }}</b></p>
            <p>Capital social : <b class="text-primary">{{ associate.company.shareCapital }}</b></p>
            <p>Forme sociale : <b class="text-primary">{{ associate.company.socialForm }}</b></p>
        </div>

        <p v-if="associate.contribution.numerary.active">Apport numéraire : <b class="text-primary">{{ associate.contribution.numerary.amount }}</b></p>

        <div v-if="associate.contribution.inKind.active">
					<div v-if="associate.contribution.inKind.contributions.length > 1">
						<p>Apports en nature</p>
						<b-tabs justified>
							<b-tab v-for="(inKindContribution,index) in associate.contribution.inKind.contributions" :key="index" :title="tabTitle(index)" class="pt-3">
								<p v-if="index === 5">L'associé contribue à plus de 5 apports en nature</p>

								<span v-else>Apport : <b class="text-primary">{{ inKindContribution }}</b></span>
							</b-tab>
						</b-tabs>
					</div>

					<span v-else>Apport en nature : <b class="text-primary">{{ associate.contribution.inKind.contributions[0] }}</b></span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            associate : {
                type: Object,
                required: true
            }
        },
        methods : {
            tabTitle(index) {
                if (index === 5) {
                    return "+5";
                } else {
                    index ++;
                    const title = index.toString();
                    return title;
                }
            }
        }
    }
</script>
